import type { RaspadinhaCampaign } from '@/types/raspadinha-campaign'
import { ensureDateWinningSchedules, validateWinningDateSchedules } from './date-winning-schedules'
import { isValidRaspadinhaCampaignSlug } from './slug'
import { validateContemplatedPrizeImages } from './contemplated-prize-images'
import { validateCustomDocuments } from './custom-documents'
import { validateReadingCriteria } from './reading-criteria'
import { validateRaspadinhaRegulation } from './validate-regulation'

type ValidateRaspadinhaCampaignSaveOptions = {
  hasPendingGeneratedSchedules?: boolean
  hasPendingPeriodChange?: boolean
}

export function validateRaspadinhaCampaignSave(
  form: RaspadinhaCampaign,
  options: ValidateRaspadinhaCampaignSaveOptions = {}
): string | null {
  if (options.hasPendingPeriodChange) {
    return 'Existem alterações pendentes no período da campanha. Clique em Alterar período antes de salvar.'
  }

  if (options.hasPendingGeneratedSchedules) {
    return 'Existem horários gerados aguardando salvamento na aba Contemplações. Salve ou descarte antes de salvar a campanha.'
  }

  if (!form.name.trim()) {
    return 'Informe o nome da campanha.'
  }

  if (!isValidRaspadinhaCampaignSlug(form.slug)) {
    return 'O slug informado é inválido. Use apenas letras minúsculas, números e hífens.'
  }

  if (form.starts_at && form.ends_at) {
    const startMs = new Date(form.starts_at).getTime()
    const endMs = new Date(form.ends_at).getTime()
    if (!Number.isNaN(startMs) && !Number.isNaN(endMs) && startMs > endMs) {
      return 'A data de início deve ser anterior à data de encerramento.'
    }
  }

  const contemplatedPrizesError = validateContemplatedPrizeImages(form.contemplated_prize_images)
  if (contemplatedPrizesError) {
    return contemplatedPrizesError
  }

  const customDocumentsError = validateCustomDocuments(form.custom_documents ?? [])
  if (customDocumentsError) {
    return customDocumentsError
  }

  const readingCriteriaError = validateReadingCriteria(form.reading_criteria ?? [])
  if (readingCriteriaError) {
    return readingCriteriaError
  }

  const schedulesError = validateWinningDateSchedules(
    ensureDateWinningSchedules(form.winning_date_schedules, form.starts_at, form.ends_at),
    form.contemplated_prize_images
  )
  if (schedulesError) {
    return schedulesError
  }

  return validateRaspadinhaRegulation()
}
